var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9198 3.39199C8.47047 3.26309 9.03426 3.19866 9.5998 3.19999C15.1998 3.19999 18.3998 9.59999 18.3998 9.59999C17.9142 10.5085 17.335 11.3638 16.6718 12.152M11.2958 11.296C11.0761 11.5318 10.8111 11.7209 10.5167 11.8521C10.2223 11.9833 9.90453 12.0538 9.58228 12.0595C9.26003 12.0652 8.93993 12.0059 8.64109 11.8852C8.34225 11.7645 8.07078 11.5848 7.84288 11.3569C7.61498 11.129 7.43532 10.8575 7.31461 10.5587C7.1939 10.2599 7.13463 9.93976 7.14031 9.61752C7.146 9.29527 7.21653 8.97746 7.34771 8.68307C7.47888 8.38867 7.66801 8.12371 7.9038 7.90399M14.3518 14.352C12.9843 15.3944 11.3191 15.9719 9.5998 16C3.9998 16 0.799805 9.59999 0.799805 9.59999C1.79492 7.7455 3.17511 6.12527 4.8478 4.84799L14.3518 14.352Z",
    stroke: "#304571",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.800007L18.3998 18.4",
    stroke: "#304571",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/Eye_Off.7034604f50a9b5703ffdb503f7ca462c.svg";
export { ForwardRef as ReactComponent };